import { jsx as _jsx } from "react/jsx-runtime";
import '@/styles/UI/NotificationPopup.less';
const NotificationPopup = ({ notificationList, timeout = 3000, }) => {
    if (!notificationList || notificationList.length === 0)
        return null;
    const fadeInTime = 150;
    const fadeOutTime = 150;
    const holdTime = timeout - fadeInTime - fadeOutTime;
    return (_jsx("div", { className: "notification-stack", children: notificationList.map((n) => (_jsx("div", { className: `notification-popup ${n.type === 'error' ? 'error-popup' : ''}`, style: {
                animation: `
                fadeIn ${fadeInTime}ms ease-in-out forwards,
                hold ${holdTime}ms ease-in-out ${fadeInTime}ms forwards,
                fadeOut ${fadeOutTime}ms ease-in-out ${fadeInTime + holdTime}ms forwards
              `,
                animationFillMode: 'forwards',
            }, children: n.message }, n.id))) }));
};
export default NotificationPopup;
